var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nettdoc-button",class:_vm.active ? 'nettdoc-active' : '',on:{"click":function($event){_vm.active ? _vm.$emit('action') : null}}},[_c('p',[_vm._v(_vm._s(_vm.$t(_vm.text)))])])}
var staticRenderFns = []

export { render, staticRenderFns }